import { Fragment, useMemo } from "react"
import { RenderPlantDetail } from "./PlantDetail"

export const SearchPlant = ({
  searchTerm,
  setSearchTerm,
  filteredPlants,
  setIsIconSwitchingAndAuto,
  solarPlants,
  handleSidebarClick,
  setSiteId,
  emitStopScrollString,
}) => {
  const countKeywordMatch = (name, keyword) => {
    const lowerName = name.toLowerCase()
    const lowerKeyword = keyword.toLowerCase()

    return [...lowerKeyword].reduce((score, char) => {
      const regex = new RegExp(char, "g")
      const matches = lowerName.match(regex)
      return score + (matches ? matches.length : 0)
    }, 0)
  }

  const filteredAndSortedPlants = useMemo(() => {
    if (!searchTerm) return solarPlants

    return [...(solarPlants || [])]
      .map((plant) => ({
        ...plant,
        matchScore: countKeywordMatch(plant.siteName, searchTerm),
      }))
      .filter((plant) => plant.matchScore > 0)
      .sort((a, b) => b.matchScore - a.matchScore)
      .slice(0, 3)
  }, [solarPlants, searchTerm])

  const ongChangeSearch = () => {
    setIsIconSwitchingAndAuto(false)
    emitStopScrollString(false)
  }

  return (
    <>
      <div style={{ position: "relative", marginBottom: 14 }}>
        <img
          src={`${process.env.PUBLIC_URL}/icons/maginfying_glass.svg`}
          alt="maginfying_glass"
          style={{
            position: "absolute",
            top: "50%",
            left: 12,
            transform: "translateY(-50%)",
            width: 16,
            height: 16,
            pointerEvents: "none",
          }}
        />

        <style>
          {`
          .input-custom::placeholder {
            font-family: noto-sans, sans-serif;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            letter-spacing: 0;
            color: #0000004D;
          }
        `}
        </style>

        <input
          type="text"
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value)
            if (e.target.value !== "") {
              ongChangeSearch()
            }
          }}
          onFocus={() => {
            ongChangeSearch()
          }}
          placeholder="Search Plant..."
          className="input-custom"
          style={{
            width: "100%",
            padding: "10px 32px 10px 32px",
            fontSize: 14,
            borderRadius: 12,
            border: "2px solid #0000004D",
            boxSizing: "border-box",
            color: "#1F1F21",
            fontFamily: "noto-sans, sans-serif",
          }}
        />

        {searchTerm !== "" && (
          <button
            onClick={() => setSearchTerm("")}
            style={{
              position: "absolute",
              top: "50%",
              right: 12,
              transform: "translateY(-50%)",
              width: 20,
              height: 20,
              border: "none",
              borderRadius: 10,
              padding: "0px 4px 4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#F3F3F3E5",
              color: "#0000004D",
            }}>
            x
          </button>
        )}
      </div>

      {searchTerm !== "" && filteredPlants.length === 0 && (
        <Fragment>
          <div
            style={{
              fontFamily: "noto-sans, sans-serif",
              fontWeight: 500,
              fontSize: "14px",
              lineHeight: "140%",
              letterSpacing: "0%",
              textAlign: "center",
              padding: "20px",
              backgroundColor: "#F3F3F3E5",
              borderRadius: "12px",
              color: "#1F1F21",
              marginBottom: 20,
            }}>
            <div>No results found.</div>
            <div
              style={{
                fontWeight: 300,
                fontSize: "12px",
                letterSpacing: "2%",
                marginTop: 6,
              }}>
              Please check the site name <br /> and try searching again.
            </div>
          </div>

          <div
            style={{
              fontFamily: "noto-sans, sans-serif",
              fontWeight: 500,
              fontSize: "16px",
              lineHeight: "140%",
              letterSpacing: "0%",
              marginBottom: 16,
              color: "#1F1F21",
            }}>
            <p style={{ margin: "0 0 2px" }}>You might looking for...</p>
            <p style={{ fontWeight: 400, fontSize: "12px", letterSpacing: "2%", margin: "0" }}>we listed up based on your search.</p>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 12,
              paddingBottom: 12,
              overflow: "hidden",
            }}>
            {filteredAndSortedPlants.map((plant, index) => {
              return (
                <div
                  key={plant?.siteId || index}
                  onClick={() => {
                    setIsIconSwitchingAndAuto(false)
                    emitStopScrollString(false)

                    const sid = Number(plant?.siteId)
                    setSiteId(null)
                    setTimeout(() => setSiteId(sid), 0)

                    handleSidebarClick(plant)

                    setSearchTerm("")
                  }}
                  style={{
                    border: "1px solid #ddd",
                    background: "#F3F3F3",
                    borderRadius: 12,
                    padding: "8px 12px",
                    cursor: "pointer",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                    transition: "all 0.3s",
                    minHeight: 120,
                  }}>
                  <RenderPlantDetail plant={plant} />
                </div>
              )
            })}
          </div>
        </Fragment>
      )}
    </>
  )
}
